<template lang="pug">
//- .searchbar
//-   .input-group
//-     .input-group-prepend
//-       span.input-group-text(@click="handleSearch")
//-         i.fad.fa-search
//-     //- input.form-control#searchName(v-model="searchName" type="text" :placeholder="$t('ui.search_team')" @blur="handleSearch")
//-     input.form-control#searchName(v-model="searchName" type="text" :placeholder="$t('ui.search_team')")
//-     .input-group-prepend(v-if="search")
//-       span.input-group-text.clickable(@click="clear")
//-         i.fas.fa-times.text-white-50
//-     .input-group-prepend.cancel
//-       span(@click="handleSearch") {{ $t("ui.search") }}
//-     #cancel-search.input-group-prepend.cancel
//-       span(@click="close") {{ $t("ui.close") }}

.searchbar
  .input-group
    .input-group-prepend
      span.input-group-text(@click="handleSearch")
        i.fa-solid.fa-magnifying-glass
    input.form-control(v-model="searchName" type="text" :placeholder="$t('ui.search_team')")
    .input-group-prepend(v-if="search")
      span.input-group-text.clickable(@click="clear")
        i.fas.fa-times.text-white-50
  button.btn-search(@click="handleSearch") {{ $t("ui.search") }}
  #cancel-search.input-group-prepend.cancel(@click="close")
    span
      i.fas.fa-times.text-white-50
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {},
  data() {
    return {
      searchName: this.search
    }
  },
  computed: {
    search() {
      return this.$store.getters.search;
    }
  },
  mounted() {
    EventBus.$on("GET_SEARCH", this.handleSearch);
  },
  destroyed() {
    EventBus.$off("GET_SEARCH", this.handleSearch);
  },
  methods: {
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
      }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    handleSearch(e) {
      this.$store.dispatch("layout/setSearch", this.searchName);
      if (this.searchName == "" || this.searchName == null) {
        this.$store.dispatch("layout/setMenu", { property: "menu0", value: "all" });
      } else {
        this.$store.dispatch("layout/setMenu", { property: "menu0", value: "search" });
      }
      EventBus.$emit("INVALIDATE");
      this.$emit("result", this.searchName);
    },
    clear() {
      this.searchName = null;
      this.$store.dispatch("layout/setSelectedMatch", null);
      this.clearSearch();
      this.resetSelectLeague();
      this.$store.dispatch("layout/setMenu", { property: "menu0", value: "all" });
      EventBus.$emit("INVALIDATE");
      this.$emit("result", null);
    },
    close() {
      this.searchName = null;
      $("#search-modal").fadeOut();
      $("body").removeClass("open-side-nav");
      this.$store.dispatch("layout/setSelectedMatch", null);
      this.clearSearch();
      this.resetSelectLeague();
      this.$store.dispatch("layout/setMenu", { property: "menu0", value: "all" });
      EventBus.$emit("INVALIDATE");
      if(this.$route.path != '/prematch') {
        this.$router.push("/prematch").catch(err => {});
      }
    }
  }
};
</script>
